<div class="cem-modal">
  <div class="cem-icon">
    <mat-icon>check_circle</mat-icon>
  </div>
  <h2 class="cem-title">Contraseña actualizada</h2>
  <p class="cem-body">Ya puedes ingresar con tu nueva contraseña.</p>
  <button mat-raised-button class="cem-btn" (click)="ingresar()">
    Ingresar &nbsp;<mat-icon>east</mat-icon>
  </button>
</div>
